import { useContext } from 'react';
import contexts from './contexts';

const useStores = () => useContext(contexts.storesContext);

export default useStores;
